import { render, staticRenderFns } from "./PayBox.vue?vue&type=template&id=c00b0684&"
import script from "./PayBox.vue?vue&type=script&lang=js&"
export * from "./PayBox.vue?vue&type=script&lang=js&"
import style0 from "./PayBox.vue?vue&type=style&index=0&id=c00b0684&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports